module.exports = __webpack_public_path__ + "media/images/ppds-logo-white-812b15a92d9e6bda6c24e189ec00ce1a.png";